import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import { clikkleApps } from "../components/SidebarUtils";
//mui component
import {
  AppBar,
  Box,
  Stack,
  Drawer as MuiDrawer,
  IconButton,
  ListItemIcon,
  // ListItemText,
  // Divider,
  // Avatar,
  Button,
  Grid,
  Toolbar,
  Typography,
  // ListItemButton,
  Menu,
  Link as MuiLink,
  MenuItem,
  Modal,
  // useTheme as useMuiTheme,
  Skeleton,
  // LinearProgress,
  styled,
  useMediaQuery,
  LinearProgress,
} from "@mui/material";

//mui icons
import { IoVideocamOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import { TbBellRinging2 } from "react-icons/tb";

import AppsIcon from "@mui/icons-material/Apps";
// import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { MdModeEditOutline } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
// import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import HeaderTabs from "./FreeTab/HeaderTabs";
import MobileHeaderTabs from "./FreeTab/MobileHeaderTabs";

//react component
import Image from "../components/Image";

//services
import { useTheme } from "../style/theme";
import { useMenu } from "../hooks/useMenu";
// import EditIcon from "@mui/icons-material/Edit";
// import DoneIcon from "@mui/icons-material/Done";
import SearchBar from "./SearchBar";
import axios from "axios";
import { useMessage } from "./Header";
import { useUser } from "../hooks/Authorize";
import useModal from "./../hooks/useModal";
// import ActionIcon from "./ActionIcon";
import { getCookie } from "../utilities/cookies";
import { env } from "../utilities/function";
// import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Feedback from "./Feedback";
// import MicrophoneIcon from "./MicrophoneIcon";
// import Subscriptions from "./SubScriptionsTab/Subscriptions";
import ClikkleAds from "../assets/ClikkleFavicons/Clikkle Ads favicon.png";
import ClikkleMail from "../assets/ClikkleFavicons/Clikkle Mail-01.png";
import ClikkleCampaigns from "../assets/ClikkleFavicons/Clikkle Campaigns favicon.png";
import ClikkleEsign from "../assets/ClikkleFavicons/Clikkle E-sign-favicon.png";
import ClikkleFiles from "../assets/ClikkleFavicons/Clikkle Files favicon.png";
import ClikkleHost from "../assets/ClikkleFavicons/Clikkle Host-favicon.png";
import ClikklePitch from "../assets/ClikkleFavicons/Clikkle Pitch-favicon.png";
import ClikkleProject from "../assets/ClikkleFavicons/Clikkle Projects-01.png";
import ClikkleLaunch from "../assets/ClikkleFavicons/Clikkle Launch favicon.png";
import ClikkleHr from "../assets/ClikkleFavicons/hr.png";
import ProfileMenuModal from "./ProfileMenuModal";

const clikkleApps = [
  {
    name: "Worksuite",
    url: "https://worksuite.clikkle.com",
    logo: "https://cdn.clikkle.com/images/worksuite/2025/clikkle%20worksuite.png",
  },
  {
    name: "Campaigns",
    url: "https://campaigns.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/campaigns/logo/2025/clikkle%20campaigns.png",
  },
  {
    name: "Chat",
    url: "https://chat.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/chat/logo/2025/clikkle%20chat.png",
  },
  {
    name: "eSign",
    url: "https://esign.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/e-sign/logo/2025/clikkle%20esign.png",
  },
  {
    name: "Files",
    url: "https://files.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/files/logo/2025/clikkle%20files.png",
  },
  {
    name: "HR",
    url: "https://hr.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/hr/logo/2025/clikkle%20hr.png",
  },
  {
    name: "Projects",
    url: "https://projects.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/projects/logo/2025/clikkle%20projects.png",
  },
  {
    name: "Calendar",
    url: "https://calendar.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/calendar/logo/2025/Clikkle%20Calendar.png",
  },
  {
    name: "Crew",
    url: "https://crew.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/crew/logo/2025/Clikkle%20Crew.png",
  },
  {
    name: "CRM",
    url: "https://crm.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/crm/2025/clikkle%20crm.png",
  },
  {
    name: "Creator AI",
    url: "https://creator.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/creator/logo/2025/Clikkle%20Creator.png",
  },
];

const drawerWidth = "70%";

const appsWidth = 54;
const miniDrawerWidth = 72;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: theme.palette.background.default,
  borderRight: "none",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.background.default,
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  borderRight: "none",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,

  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const getInitials = (user) => {
  if (user && (user.firstName || user.lastName)) {
    const firstInitial = user.firstName?.charAt(0).toUpperCase() || "";
    const lastInitial = user.lastName?.charAt(0).toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  } else return "?";
};

export default function Navbar(props) {
  const { children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [sidebarApps, setSidebarApps] = useState(clikkleApps);
  // const [isOrderChanged, setIsOrderChanged] = useState(false);
  // const [editable, setEditable] = useState(false);
  const [user, setUser] = useState(null);
  const [collapseDrawer, setCollapseDrawer] = useState(true);
  const [drawerHover, setDrawerHover] = useState(false);
  const {
    modalState: feedbackState,
    // openModal: openFeedback,
    closeModal: closeFeedback,
  } = useModal();
  const { showError } = useMessage();
  const location = useLocation();
  const platformUser = useUser();
  const matches = useMediaQuery("(min-width:1024px)", { noSsr: true });

  console.log(platformUser, "platformUserplatformUser");

  const [Profileimage, setProfileimage] = useState(
    platformUser?.profilePicture || ""
  );

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileimage(imageUrl);
      if (!file) {
        return;
      }
      const formData = new FormData();
      formData.append("profilePicture", file);
      formData.append("type", "file");
      formData.append("userId", platformUser._id);
      try {
        await axios.post(
          `https://api.files.clikkle.com/api/fs/upload-profile-picture?id=${platformUser?._id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  const { toggleTheme, mode } = useTheme();
  // const theme = useMuiTheme();

  const [searchVisible, setSearchVisible] = useState(false);

  // Toggle function for search bar
  const toggleSearchBar = () => {
    setSearchVisible((prev) => !prev);
  };

  // useMenu
  const {
    anchorEl: anchorElProfile,
    openMenu: openProfileMenu,
    closeMenu: closeProfileMenu,
  } = useMenu();

  const {
    anchorEl: anchorElApps,
    // openMenu: openAppsMenu,
    closeMenu: closeAppsMenu,
  } = useMenu();

  const {
    anchorEl: anchorElSettings,
    openMenu: openSettingsMenu,
    closeMenu: closeSettingsMenu,
  } = useMenu();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerOpen = () => {
    setCollapseDrawer(!collapseDrawer);
  };

  // const onDragEnd = (result) => {
  //   const { source, destination } = result;

  //   if (!destination) return;

  //   if (
  //     source.droppableId === destination.droppableId &&
  //     source.index === destination.index
  //   )
  //     return;

  //   // setIsOrderChanged(true);

  //   const draggingJob = sidebarApps[source.index];
  //   sidebarApps.splice(source.index, 1);

  //   sidebarApps.splice(destination.index, 0, draggingJob);
  //   setSidebarApps([...sidebarApps]);
  // };

  const getProfile = useCallback(async () => {
    const role = getCookie("role");
    const accessToken = getCookie("clikkleStoreAccessToken");

    if (!(accessToken && role)) return;

    try {
      const response = await axios.get(`/${role}/profile`, {
        baseURL: env("AUTHENTICATION_SERVER"),
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const user = response.data.user;
      setUser(user);
    } catch (err) {
      console.log(err);
    }
  }, [setUser]); // fetching user to get its personalize settings

  const getPlatforms = useCallback(async () => {
    try {
      const response = await axios.get("/platforms?sortBy=name&direction=1", {
        baseURL: env("AUTHENTICATION_SERVER"),
      });

      const { success, errors, platforms } = response.data;

      if (!success) return showError(errors);

      const SidebarApps = platforms?.filter(
        (platform) => platform.slug !== "e-sign"
      ); // Platform to exclude from list

      SidebarApps.forEach((app, i) => (app.order = i + 1));

      const arrangedOrder = [];
      user?.personalize?.appsOrder.forEach((order) => {
        SidebarApps.forEach((app, i) => {
          if (order === app.order) {
            arrangedOrder.push(app);
            SidebarApps.splice(i, 1);
          }
        });
      });

      if (arrangedOrder.length)
        setSidebarApps([...arrangedOrder, ...SidebarApps]);
      else setSidebarApps(SidebarApps);
    } catch (e) {
      console.log(e);
    }
  }, [user, showError]);

  // const saveOrder = async () => {
  //   const accessToken = getCookie("clikkleStoreAccessToken");
  //   const appsOrder = sidebarApps.map((app) => app.order);

  //   try {
  //     const response = await axios.patch(
  //       "/user/personalize",
  //       { appsOrder },
  //       {
  //         baseURL: env("AUTHENTICATION_SERVER"),
  //         headers: { Authorization: Bearer ${accessToken} },
  //       }
  //     );

  //     const { success, errors } = response.data;

  //     if (!success) return showError(errors);

  //     setCookie("side_apps_order", appsOrder);
  //     showResponse("Setting updated");
  //   } catch (e) {
  //     handleAxiosError(e, showError);
  //   } finally {
  //     // setIsOrderChanged(false);
  //   }
  // };

  const signOut = () => {
    ["user", "token", "accessToken", "refreshToken", "sessionToken", "userId"].forEach((key) => localStorage.removeItem(key));
    const accountsBase = env("AUTHENTICATION_CLIENT") || "https://accounts.clikkle.com";
    const logoutUrl = new URL("/logout", accountsBase);
    logoutUrl.searchParams.set("redirectto", "https://clikkle.com");
    logoutUrl.searchParams.set("logoutNonce", Date.now().toString());
    window.location.replace(logoutUrl.toString());
  };
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!matches) {
      setSearchVisible(false);
    }
  }, [matches]);

  // useEffect(() => {
  //   getProfile();
  // }, [getProfile]);

  useEffect(() => {
    user && getPlatforms();
  }, [user, getPlatforms]);

  // visibility for mobile view
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const shouldHideHeader =
    !isMobile &&
    (window.location.pathname.startsWith("/subscription/hr/purchase") ||
      window.location.pathname.startsWith("/subscription/files/purchase") ||
      window.location.pathname.startsWith("/subscription/esign/purchase") ||
      window.location.pathname.startsWith("/subscription/Projects/purchase") ||
      window.location.pathname.startsWith("/pay-step-files"));

  const drawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
    >
      {!window.location.pathname.startsWith("/plan-details") &&
      !window.location.pathname.startsWith("/pay-step") &&
      !window.location.pathname.startsWith("/subscription/hr/purchase") &&
      !window.location.pathname.startsWith("/subscription/files/purchase") &&
      !window.location.pathname.startsWith("/subscription/esign/purchase") &&
      !window.location.pathname.startsWith("/confirm-subscription") &&
      !window.location.pathname.startsWith(
        "/subscription/Projects/purchase"
      ) ? (
        <MobileHeaderTabs />
      ) : (
        <> </>
      )}
    </Box>
  );
  const miniDrawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
    >
      {!window.location.pathname.startsWith("/plan-details") &&
      !window.location.pathname.startsWith("/pay-step") &&
      !window.location.pathname.startsWith("/subscription/hr/purchase") &&
      !window.location.pathname.startsWith("/subscription/files/purchase") &&
      !window.location.pathname.startsWith("/subscription/esign/purchase") &&
      !window.location.pathname.startsWith("/subscription/Projects/purchase") &&
      !window.location.pathname.startsWith("/plan-details/:planId") &&
      !window.location.pathname.startsWith("/confirm-subscription") ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          component={Link}
          mb={1.5}
          to="/"
          sx={{
            textDecoration: "none",
            color: "text.primary",
            py: 0.9,
            //  ml:"1rem",
            // borderBottom: "1px solid #424242",
            borderBottom: window.location.pathname.startsWith(
              "/some-other-route"
            )
              ? "none"
              : "1px solid #424242", // Example of conditionally hiding the border
          }}
        >
          <Image
            cdn="store/logo/Clikkle Store Icon.png"
            sx={{ height: "50px" }}
          />
          <h6>Clikkle Store</h6>
        </Box>
      ) : (
        <> </>
      )}

      <Box
        sx={{
          overflowY: "auto",
          height: "calc(100dvh - 90px)",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <HeaderTabs /> */}
      </Box>
    </Box>
  );

  console.log({ drawerHover });

  let currentStorage = JSON.parse(localStorage.getItem("storage"));
  let currentUserStorage = JSON.parse(localStorage.getItem("userStorage"));

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
  };

  const convertToBytes = (value, unit) => {
    const units = {
      Bytes: 1,
      KB: 1024,
      MB: 1024 ** 2,
      GB: 1024 ** 3,
      TB: 1024 ** 4,
    };
    return value * (units[unit] || 1);
  };

  const used = currentUserStorage?.usedSpace || 0;
  const limit = convertToBytes(
    currentStorage?.permissions?.noOfAllowed || 0,
    currentStorage?.permissions?.format || "GB"
  );

  const percentage = limit > 0 ? (used / limit) * 100 : 0;

  return (
    <Box
      sx={{
        // bgcolor: "background.main",
        px: { xs: 0.5, xm: 0 },
        height: "100dvh",
        position: "relative",
      }}
    >
      {!window.location.pathname.startsWith("/plan-details") &&
      !window.location.pathname.startsWith("/pay-step") &&
      !window.location.pathname.startsWith("/confirm-subscription") &&
      !shouldHideHeader ? (
        <AppBar
          elevation={0}
          component={Box}
          position="sticky"
          sx={{
            // width: {
            //   xs: "100%",
            //   xm:
            //     collapseDrawer && !drawerHover
            //       ? `calc(100% - ${drawerWidth}px)`
            //       : `calc(100% - ${miniDrawerWidth}px )`,
            // },
            // ml: {
            //   xm:
            //     collapseDrawer && !drawerHover
            //       ? `${drawerWidth}px`
            //       : `${miniDrawerWidth}px`,
            // },
            backgroundColor: "background.default",

            // borderBottomColor: 'custom.border',
            // borderBottom: isMobile ? "none" : "1px solid #424242",

            color: "text.primary",
            transition: "ease-in-out 225ms, background-color 0s",
          }}
        >
          {/* <HeaderTabs /> */}

          <Toolbar
            sx={{
              flexDirection: "column",
              justifyContent: "center",
              position: "relative",
              "&": {
                minHeight: "64px",
                px: 1,
              },
            }}
          >
            <Grid
              columnSpacing={2}
              className="flex items-center justify-between w-full"
            >
              <Grid item style={{ display: matches ? "none" : "block" }}>
                <IconButton
                  onClick={matches ? handleDrawerOpen : handleDrawerToggle}
                  edge="start"
                  sx={{
                    ml: 0.2,
                    mr: 1,
                  }}
                >
                  <RxHamburgerMenu sx={{ fontSize: "30px" }} />
                </IconButton>
              </Grid>
              {/* <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          component={Link}
          to="/"
          sx={{ textDecoration: "none", color: "text.primary", py: 1 }}
        >
          <Image
            cdn="store/logo/Clikkle Store Logo.png"
            sx={{
               height: "28px",
               width:"135px"
              //  mr:"1rem"
                }}
          />
        </Box> */}

              {/* <Subc */}
              {/* <HeaderTabs /> */}
              <Grid
                item
                sx={{
                  display: matches ? "block" : "none", // Hide on mobile, show on desktop
                }}
                //  display="flex"
                justifyContent="start"
              >
                <HeaderTabs />
              </Grid>

              <Grid item xs md={isMobile ? 3 : 2} alignItems="start">
                {searchVisible && <SearchBar />} {!matches && <SearchBar />}
                {/* Render SearchBar based on state */}
              </Grid>
              <Grid item xs display={{ xs: "none", sm: "block" }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-end"
                  spacing={0}
                ></Stack>
              </Grid>

              {/* <IconButton>
              <BsPlusLg />
              </IconButton> */}

              <Grid item xs display={{ xs: "none", sm: "block" }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-end"
                  spacing={0}
                >
                  {matches ? (
                    <IconButton onClick={toggleSearchBar}>
                      <IoIosSearch />
                    </IconButton>
                  ) : (
                    ""
                  )}
                  <IconButton>
                    <TbBellRinging2
                      sx={{
                        transform: "rotate(15deg)", // Tilt left
                        fontSize: 24, // Adjust size if needed
                      }}
                    />
                  </IconButton>

                  {/* <IconButton>
                    <PiChatTeardropText />
                  </IconButton> */}

                  <IconButton>
                    <IoVideocamOutline />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      window.location.href = "https://worksuite.clikkle.com/products";
                    }}
                  >
                    <AppsIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorElApps}
                    open={Boolean(anchorElApps)}
                    onClose={closeAppsMenu}
                    sx={{
                      ".MuiPaper-root.MuiMenu-paper.MuiPopover-paper": {
                        marginTop: "16px",
                        bgcolor: "custom.menu",
                        width: "300px",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        border: "1px solid rgba(0, 0, 0, 0.11)",
                      },
                    }}
                  >
                    <Grid container alignItems="center" spacing={2}>
                      {sidebarApps
                        ? sidebarApps.map((app) => (
                            <Grid item xs={4} key={app.name}>
                              <MuiLink
                                href={app.url}
                                target="_blank"
                                sx={{
                                  fontWeight: 500,
                                  textDecoration: "none",
                                  color: "#5f6368",
                                }}
                              >
                                <Box
                                  align="center"
                                  sx={{
                                    borderRadius: "8px",
                                    p: 1.2,
                                    textAlign: "center",
                                    "&:hover": {
                                      bgcolor: "custom.appsHover",
                                    },
                                  }}
                                >
                                  <Image
                                    src={app.logo}
                                    sx={{
                                      height: "35px",
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      overflowX: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      fontWeight: 500,
                                    }}
                                  >
                                    {app.name}
                                  </Typography>
                                </Box>
                              </MuiLink>
                            </Grid>
                          ))
                        : Array(9)
                            .fill(0)
                            .map((_, i) => (
                              <Grid item xs={4} key={i} align="center">
                                <Skeleton
                                  variant="circular"
                                  animation="wave"
                                  width={37}
                                  height={37}
                                  sx={{ mt: 1 }}
                                />
                                <Skeleton
                                  variant="text"
                                  animation="wave"
                                  width={38}
                                  sx={{ mt: 1 }}
                                />
                              </Grid>
                            ))}
                    </Grid>
                  </Menu>

                  <IconButton onClick={openSettingsMenu}>
                    <IoSettingsOutline />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElSettings}
                    open={Boolean(anchorElSettings)}
                    onClose={closeSettingsMenu}
                  >
                    <MenuItem onClick={toggleTheme}>
                      <ListItemIcon>
                        {mode === "dark" ? (
                          <LightModeIcon fontSize="small" />
                        ) : (
                          <DarkModeIcon fontSize="small" />
                        )}
                      </ListItemIcon>
                      Appearance
                    </MenuItem>
                  </Menu>
                </Stack>
              </Grid>
              <IconButton
                onClick={openProfileMenu}
                sx={{
                  width: "45px",
                  height: "45px",
                  padding: 0,
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderColor: "#3b84d9",
                  borderRadius: "50%", // makes it round
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {platformUser?.profilePicture ? (
                  <img
                    src={platformUser?.profilePicture}
                    alt="Profile"
                    decoding="async"
                    loading="lazy"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography
                    variant="subtitle1"
                    fontWeight={500}
                    fontSize={14}
                    sx={{
                      color: "#3b84d9",
                    }}
                  >
                    {platformUser?.firstName && platformUser?.lastName
                      ? platformUser.firstName.charAt(0).toUpperCase() +
                        platformUser.lastName.charAt(0).toUpperCase()
                      : "?"}
                  </Typography>
                )}
              </IconButton>

              <ProfileMenuModal
                anchorElProfile={anchorElProfile}
                closeProfileMenu={closeProfileMenu}
              />
            </Grid>
          </Toolbar>
          {/* <Grid
                item
                sx={{
                  display: matches ? "none" : "block" ,
                  borderTop: isMobile ? "1px solid #424242" : "none",
                }}
                //  display="flex"
                justifyContent="start"
              >
                <MobileHeaderTabs />
              </Grid> */}
        </AppBar>
      ) : (
        <> </>
      )}
      <Box
        component="nav"
        sx={{
          width: { xm: drawerWidth, sm: 0, md: 0, lg: 0, xl: 0 },
          flexShrink: { sm: 0 },
          bgcolor: "custom.menu",
        }}
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: matches ? "none" : "block",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: "custom.menu",
            },
          }}
        >
          {drawer}
        </MuiDrawer>
        <Drawer
          variant="permanent"
          open={collapseDrawer}
          hover={drawerHover}
          // onMouseOver={() => {
          //   if (!collapseDrawer) {
          //     setCollapseDrawer(true);
          //     setDrawerHover(true);
          //   }
          // }}
          onMouseLeave={() => {
            if (drawerHover) {
              setCollapseDrawer(false);
              setDrawerHover(false);
            }
          }}
          sx={{
            display: { xs: "none", xm: "none" },
            p: 0,
            "& .MuiDrawer-paper": {
              boxShadow: drawerHover
                ? "rgba(149, 157, 165, 0.2) 0px 8px 24px"
                : "none",
            },
          }}
        >
          {collapseDrawer ? drawer : miniDrawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          width: {
            xs: "100%",
            xm:
              collapseDrawer && !drawerHover
                ? `calc(100% - ${matches ? 5 : drawerWidth + appsWidth}px)`
                : `calc(100% - ${appsWidth + miniDrawerWidth}px )`,
          },
          ml: {
            xm:
              collapseDrawer && !drawerHover
                ? `${matches ? 5 : drawerWidth}px`
                : `${miniDrawerWidth}px`,
          },
          mt: 1,
          height: { xs: "calc(100dvh - 90px)" },
          borderRadius: "12px",
        }}
      >
        {children}
      </Box>
      <Modal
        open={feedbackState}
        onClose={closeFeedback}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <>
          <Feedback closeModal={closeFeedback} />
        </>
      </Modal>
    </Box>
  );
}
